// React
import React, { useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

// Components
import BPeriod from 'shop-components/components/MiniCart/styles/Period'
import Span from 'ui/elements/Span'
import { FulfillmentDetails } from 'shop-components/components/MiniCart/components/FulfillmentDetails'

// Hooks
import { useTranslation } from 'shared/utils/useTranslation'
import { useSettings } from 'shared/utils/useSettings'
import { useSelector } from 'react-redux'

// Shared
import moment from 'shared/lib/moment'
import ClientActions from 'store/v2/redux/actions/client'

export const Period = ({ autoOpenedModal, onAutoModal, hasDates, cart, locations }) => {
  const open = useSelector((state) => state.client.cartOpen)
  const modalOpen = useSelector((state) => state.client.modalPickerOpen)

  let dateFormat = 'MMM DD'
  let timeFormat = 'HH:mm'

  const useAmPm = useSettings('dates.use_am_pm')
  const useTimes = useSettings('store.use_times')

  const isSameYear = moment(cart?.starts_at).isSame(moment(), 'year')

  if (isSameYear) {
    dateFormat = 'MMM D'
  } else {
    dateFormat = 'MMM D YYYY'
  }

  if (useAmPm) {
    timeFormat = 'hh:mm A'
  } else {
    timeFormat = 'HH:mm'
  }

  const format = useTimes ? `${dateFormat}, ${timeFormat}` : dateFormat

  const handleOpenPicker = useCallback(() => {
    ClientActions.toggleModalPicker(true)
  }, [])

  useEffect(() => {
    if (!autoOpenedModal && open && !hasDates && !modalOpen) {
      onAutoModal(() => {
        handleOpenPicker()
      })
    }
  }, [autoOpenedModal, open, hasDates, modalOpen, handleOpenPicker])

  const { t } = useTranslation('user')

  const hasLocations = locations.size() > 1

  return (
    <BPeriod data-tid="Select dates" onClick={handleOpenPicker}>
      {hasDates && (
        <BPeriod.WithDates className="bq-selected-dates">
          <BPeriod.Dates>
            <BPeriod.Details>
              <FulfillmentDetails cart={cart} locations={locations} hasLocations={hasLocations} />
              <BPeriod.Detail>
                <Span>{moment(cart?.starts_at).format(format)}</Span>
                <Span>&nbsp;-&nbsp;</Span>
                <Span>{moment(cart?.stops_at).format(format)}</Span>
              </BPeriod.Detail>
            </BPeriod.Details>
          </BPeriod.Dates>
        </BPeriod.WithDates>
      )}
      {!hasDates && (
        <BPeriod.NoDates className="bq-branded-border">
          <BPeriod.Dates>
            <BPeriod.ChoosePeriod>{t('user.store.select_a_period')}</BPeriod.ChoosePeriod>
          </BPeriod.Dates>
        </BPeriod.NoDates>
      )}
    </BPeriod>
  )
}

Period.displayName = 'Period'

Period.propTypes = {
  cart: PropTypes.object,
  hasDates: PropTypes.bool,
  locations: PropTypes.object,
  onAutoModal: PropTypes.func,
  autoOpenedModal: PropTypes.bool
}

export default Period
